import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import dataCacheService from '@/shared/services/DataCacheService';

//List link types that should be hidden for a relation type
const linkTypesHiddenFor = {
  //Company
  0: [5, 9],
  //SoleProp
  1: [],
  //Person
  2: [2, 3, 4, 6, 8, 11],
};

const searchOptionsForLinkType = {
  5: { type: [1, 2] }, //Partner
  9: { type: [1, 2] }, //Child
  11: { type: [0, 1] }, //Holding
  11: { type: [0] }, //VAT unit
};

angular
  .module('cloudX')
  .controller('AddRelationLinkDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    '$element',
    'close',
    'enumCacheSvc',
    'dialogsSvc',
    'relationId',
    'companyId',
    'relationType',
    'translateListFilter',
    'checkTenantConfiguration',
    addRelationLinkDialogCtrl,
  ]);

function addRelationLinkDialogCtrl(
  resourceFactorySvc,
  flySvc,
  $element,
  close,
  enumCacheSvc,
  dialogsSvc,
  relationId,
  companyId,
  relationType,
  translateListFilter,
  checkTenantConfiguration,
) {
  var vm = this;
  vm.loading = false;
  vm.representedByWizardOptions = { allowedRelTypes: [1, 2], showKBO: false };
  vm.representedBySearchOptions = { type: [1, 2] };
  vm.relationSearchOptions = {};
  vm.shareholderGroups = null;
  vm.isNetherlandsConfiguration = checkTenantConfiguration('[5]');
  vm.netherlandsMate = 97;
  vm.netherlandsDirector = 98;
  vm.netherlandsAssociate = 99;
  vm.commonLinkTypes = [1, 2, 3, 6, 4]; // contact, beneficiary, trustee, shareholder,company owner (last due to dropdown)
  vm.selectedCommonLinkTypes = [];
  vm.hasPortalConnectPlatform = dataCacheService.hasPortalConnectPlatform(companyId);
  vm.relationType = relationType;

  vm.relationLink = {
    linkType: null,
    remark: '',
    extraValues: {},
  };

  if (vm.isNetherlandsConfiguration) {
    vm.commonLinkTypes = vm.commonLinkTypes.filter(function(type) {
      return type !== 3;
    });
  }

  var resource = resourceFactorySvc.get('relationLink');
  enumCacheSvc.get('linkType').then(function(data) {
    vm.linkTypes = data
      .filter(x => linkTypesHiddenFor[relationType].indexOf(x.key) < 0)
      .map(x => ({
        ...x,
        label: translateListFilter(x.key, 'linktypeto', x.value),
      }))
      .sort(dynamicSort('label'));
    if (vm.isNetherlandsConfiguration) {
      // NL: remove bedrijfsleider label, add vennoot & bestuurder
      vm.linkTypes = [
        { key: vm.netherlandsMate, label: translateListFilter(17, 'CompanyOwnerPosition') }, // add maat
        { key: vm.netherlandsDirector, label: translateListFilter(3, 'CompanyOwnerPosition') }, // add bestuurder
        { key: vm.netherlandsAssociate, label: translateListFilter(5, 'CompanyOwnerPosition') }, // add vennoot
        ...vm.linkTypes.filter(x => x.key !== 4), // remove 'normal' company owner link type
      ].sort(dynamicSort('label'));
    }
  });
  enumCacheSvc.get('companyownerposition').then(function(data) {
    vm.positions = data
      .map(x => ({
        ...x,
        label: translateListFilter(x.key, 'companyownerposition', x.value),
      }))
      .sort(dynamicSort('label'));
  });
  enumCacheSvc.get('partnershiptype').then(function(data) {
    vm.partnershipTypes = data;
  });
  enumCacheSvc.get('marriageregime').then(function(data) {
    vm.marriageRegimes = data;
  });
  enumCacheSvc.get('marriageregime').then(function(data) {
    vm.marriageRegimesForLegalCohabitation = data.filter(
      x => x.key === 1 || x.key === 2 || x.key === 3,
    );
  });
  enumCacheSvc.get('propertyright').then(function(data) {
    vm.popertyRights = data;
  });

  vm.linkTypeChanged = function() {
    vm.relationLink.extraValues = {}; // Clear all extra values when selecting other link type
    vm.selectedCommonLinkTypes = [];
    vm.relationSearchOptions = searchOptionsForLinkType[vm.relationLink.linkType] || {};
    if (vm.relationLink.linkType === 6) {
      // Shareholders
      vm.relationLink.extraValues.propertyRight = 2; // FullOwnership
      vm.loadShareholderGroups();
    }
  };

  vm.showOtherCommonLinkTypes = () => {
    if (!vm.relationLink.linkType) return false;
    return vm.commonLinkTypes.includes(vm.relationLink.linkType);
  };

  vm.excludeCurrentLinkType = commonLinkType => {
    return commonLinkType !== vm.relationLink.linkType;
  };
  vm.commonLinkTypeSelectionChanged = (selected, commonLinkType) => {
    if (selected) {
      if (!vm.selectedCommonLinkTypes.includes(commonLinkType)) {
        vm.selectedCommonLinkTypes.push(commonLinkType);
      }
    } else {
      if (vm.selectedCommonLinkTypes.includes(commonLinkType)) {
        vm.selectedCommonLinkTypes = vm.selectedCommonLinkTypes.filter(x => x !== commonLinkType);
      }
    }
  };
  vm.validate = function() {
    return !!vm.toRelation && vm.toRelation.id !== undefined;
  };

  vm.validateRepresentedBy = function() {
    vm.invalidRepresentedBy = false;
    if (
      vm.relationLink &&
      vm.relationLink.extraValues &&
      vm.relationLink.extraValues.representedByRelation
    ) {
      // a relation has to be selected
      if (!vm.relationLink.extraValues.representedByRelation.id) {
        vm.invalidRepresentedBy = true;
        return false;
      }
    }
    return true;
  };

  vm.validateIsPortalUser = function() {
    const canSetIsPortalUser =
      vm.relationLink.linkType === 1 && relationType !== 2 && vm.toRelation.type !== 0;
    if (!canSetIsPortalUser) {
      delete vm.relationLink.extraValues.isPortalUser;
    }
  };

  vm.save = function() {
    if (!vm.validate()) return;
    if (!vm.validateRepresentedBy()) return;
    vm.validateIsPortalUser();

    vm.relationLink.toRelationId = vm.toRelation.id;
    vm.relationLink.fromRelationId = relationId;
    const copy = angular.copy(vm.relationLink);
    const transformed = resourceFactorySvc.setDatePropsToISO(copy);
    const model = angular.copy(transformed);

    // in NL they don't understand the concept of 'company owner/bedrijfsleider', they just want to select bestuurder or vennoot. We hacked the selection list so
    // that the tenant can just choose 'bestuurder', but we want to save it as link type company owner, with a position of vennoot.
    if (vm.relationLink.linkType === 97) {
      model.linkType = 4;
      model.extraValues.position = 17;
    }
    if (vm.relationLink.linkType === 98) {
      model.linkType = 4;
      model.extraValues.position = 3;
    }
    if (vm.relationLink.linkType === 99) {
      model.linkType = 4;
      model.extraValues.position = 5;
    }

    if (vm.createAsAdditionalCompanyOwnerPositions) {
      model.createAsAdditionalCompanyOwnerPositions = [vm.createAsAdditionalCompanyOwnerPositions];
    } else {
      model.createAsAdditionalCompanyOwnerPositions = [];
    }

    model.extraValues = JSON.stringify(model.extraValues);
    model.createAsAdditionalLinkTypes = vm.selectedCommonLinkTypes;
    vm.saving = true;
    resource.save(
      {},
      model,
      function(result) {
        vm.saving = false;
        $element.modal('hide');
        close(result, 500);
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };

  vm.openNewRelationDialog = function() {
    if (vm.saving) return;

    dialogsSvc.showRelationWizard('newRelation', { companyId }).then(function(result) {
      if (result && result.relation && result.relation.id) {
        vm.toRelation = result.relation;
      }
    });
  };
  vm.openNewRepresentedByDialog = function() {
    if (vm.saving) return;
    const options = angular.extend({ companyId }, vm.representedByWizardOptions);

    dialogsSvc.showRelationWizard('newRelation', options).then(function(result) {
      if (result && result.relation && result.relation.id) {
        vm.relationLink.extraValues.representedByRelation = result.relation;
      }
    });
  };

  vm.votesChanged = false;
  vm.sharesChanged = function() {
    if (vm.votesChanged) return;
    //Copy value from shares to votes
    vm.relationLink.extraValues.votes = vm.relationLink.extraValues.shares;
  };
  vm.loadShareholderGroups = function() {
    if (vm.shareholderGroups !== null) return;
    vm.shareholderGroups = [];
    resource.shareholderGroups({ id: relationId }, function(result) {
      vm.shareholderGroups = result || [];
    });
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
